import React from 'react';
import { IconProps } from '../../types/types';

const CloseIcon: React.FC<IconProps> = ({ size = '18', color = '#1E1E1E', onClick,className }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick} className={className}>
            <path d="M4.75732 13.2426L13.2426 4.75736" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.2426 13.2426L4.75732 4.75735" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export default CloseIcon;
